import type { InterceptorConfig } from '@axios-extensions/plugins-api'
import type { InternalAxiosRequestConfig } from 'axios'
import { InterceptorType } from '@axios-extensions/plugins-api'
import { i18n } from '@core/plugins/plugin-i18n'

export function AcceptLangaugeInterceptor(): InterceptorConfig<InterceptorType.REQUEST> {
  async function resolved(config: InternalAxiosRequestConfig<any>): Promise<InternalAxiosRequestConfig> {
    config.headers['Accept-Language'] = (i18n.global.locale as any)?.value ?? 'nl'

    return config
  }

  return {
    name: 'AcceptLangaugeInterceptor',
    type: InterceptorType.REQUEST,
    priority: 100,
    resolved,
  }
}
